// Silueta de vehiculo para los marcadores (de la demo comercial, apuntando al
// NORTE: el renderer la rota con el rumbo). Compartida por la torre y el
// portal del proveedor desde PP-51; el color lo pone cada superficie con su
// paleta. Es un SVG en linea como `data:` URL, que las dos CSP ya admiten en
// img-src: ningun pedido de red.
function silhouetteSvg(type, color) {
    if (type === "shuttle" || type === "bus") {
        const height = type === "bus" ? 30 : 26;
        return {
            w: 20,
            h: height,
            svg: `<svg width="20" height="${height}" viewBox="0 0 20 ${height}" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="2" width="14" height="${height - 4}" rx="4" fill="${color}" stroke="#0f172a" stroke-width="1.5"/>
      <rect x="5.5" y="4.5" width="9" height="4" rx="1.5" fill="#0f172a" opacity="0.45"/>
    </svg>`,
        };
    }
    return {
        w: 18,
        h: 22,
        svg: `<svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 1.5 C12.4 1.5 14.5 4.5 14.5 9 L14.5 17 C14.5 19.4 12.4 20.5 9 20.5 C5.6 20.5 3.5 19.4 3.5 17 L3.5 9 C3.5 4.5 5.6 1.5 9 1.5 Z" fill="${color}" stroke="#0f172a" stroke-width="1.5"/>
    <path d="M5.5 7.5 L12.5 7.5 L11.5 5 L6.5 5 Z" fill="#0f172a" opacity="0.45"/>
  </svg>`,
    };
}
/** Silueta del tipo como `data:` URL y su tamano nominal en px (apuntando al norte). */
export function vehicleSilhouette(type, color) {
    const { svg, w, h } = silhouetteSvg(type, color);
    return { url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`, width: w, height: h };
}
//# sourceMappingURL=vehicleSprite.js.map